import { render, staticRenderFns } from "./KarmaProgramEditForm.vue?vue&type=template&id=667ab476&"
import script from "./KarmaProgramEditForm.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramEditForm.vue?vue&type=script&lang=js&"
import style0 from "./KarmaProgramEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports